export enum KeyCode {
  enter = 'Enter',
  escape = 'Escape',
  arrowLeft = 'ArrowLeft',
  arrowRight = 'ArrowRight',
  arrowUp = 'ArrowUp',
  arrowDown = 'ArrowDown',
  tab = 'Tab',
}
